function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTowerSoilPlot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 19.84375 19.843751",
    id: "svg15374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-277.15624)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.20578705,
      strokeOpacity: 1
    },
    id: "rect4518-85-9-8-1-0-5-8",
    width: 19.84375,
    height: 19.84375,
    x: 0,
    y: 277.15625
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#bea488",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.17834876,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-5-38-2-5-2-0",
    width: 17.197918,
    height: 17.197918,
    x: 1.3229218,
    y: 278.47919
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 15.950966,289.47538 -3.15898,3.15898 h 1.123445 l 2.035535,-2.03554 z",
    id: "rect8773-0-3-33"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 12.195639,281.25726 -8.0945962,8.0946 v 1.12241 l 9.2170092,-9.21701 z",
    id: "rect8773-0-3-4-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "M 14.660087,281.78643 3.8116548,292.63435 h 1.123445 L 15.7825,281.78643 Z",
    id: "rect8773-0-3-5-23-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 15.950966,283.48918 -9.1451782,9.14518 h 1.12241 l 8.0227682,-8.02277 z",
    id: "rect8773-0-3-5-2-7-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 15.950966,286.48228 -6.1520792,6.15208 h 1.1224102 l 5.029669,-5.02967 z",
    id: "rect8773-0-3-5-6-4-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 6.2084068,281.25726 -2.107364,2.10736 v 1.12242 l 3.230292,-3.22978 z",
    id: "rect8773-0-3-5-23-2-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 9.2025398,281.25726 -5.101497,5.1015 v 1.12241 l 6.2239102,-6.22391 z",
    id: "rect8773-0-3-5-2-7-2-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.50760341,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 3.8364588,280.99269 v 12.17084 H 16.007293 v -12.17084 z m 1.322917,1.32292 h 9.5250002 v 9.525 H 5.1593758 Z",
    id: "rect14634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTowerSoilPlot);
export default __webpack_public_path__ + "static/media/icon-tower-soil-plot.91d1624c4552f8a5022686d014973426.svg";
export { ForwardRef as ReactComponent };